import { UserGroup } from "./usergroup.model";

export interface UserInfos {
  id: number;
  userName: string;
  groupList?: string;
  groupListCount?: number;
  role?: UserAccessRole;
  changed?: boolean;
  isGraphUser?: boolean;
  createdDate?: Date;
  lastSiteLoadDate?: Date;
  associatedUserGroups?: UserGroup[];
  //associatedItems?: UserAssociatedItem[];
}

export enum UserAccessRole {
  Unassigned = "Unassigned",
  SiteAdmin = "SiteAdmin",
  GroupFullRW = "GroupFullRW",
  GroupLimitedRW = "GroupLimitedRW",
  GroupRead = "GroupReadOnly",
  ViewListing = "ViewListing"
}

export interface UserAssociatedItem {
  id: number;
  name: string;
  type: ItemType;
  ownerName: string;
  ownerId: number;
}

export enum ItemType {
  ChartFavorite = "ChartFavorite",
  Dashboard = "Dashboard",
  Gateway = "Gateway",
  EventAction = "EventAction",
  ImportSchedule = "ImportSchedule",
  Message = "Message",
  SensorGroup = "SensorGroup",
  Sensor = "Sensor",
  ScoutviewImages = "ScoutviewImages"
}

export interface UserAssociatedCatagory {
  category: string;
  itemCount: number;
  userOwnedCount: number;
  groupOwnedCount: number;
}
